<template>
	<div v-if="$route.name!='total'" class="total">
		<div class="header">
			<el-menu router :default-active="$route.name" mode="horizontal">
				<el-menu-item index="total_survey" :route="{name:'total_survey'}">概况</el-menu-item>
				<el-menu-item index="total_order" :route="{name:'total_order'}">订单统计</el-menu-item>
				<el-menu-item index="total_driver" :route="{name:'total_driver'}">司机统计</el-menu-item>
			</el-menu>
		</div>
		<router-view ref="totalCallback"></router-view>
	</div>
</template>

<script>
	export default {
		created() {
			this.resetRoute();
		},
		methods: {
			resetRoute(){
				const that = this;
				if (that.$route.name == 'total') {
					that.$router.push({
						name: 'total_survey'
					});
				}
			}
		},
		watch: {
			$route: {
				handler: 'resetRoute'
			}
		}
	}
</script>

<style>
	.total .date_search {
		display: flex;
		justify-content: center;
		margin-bottom: 1.875rem;
	}

	.total .date_search .driver {
		width: 7rem;
		margin-left: 0.625rem;
	}

	.total .date_search .sx {
		display: flex;
		font-size: 0.875rem;
		align-items: center;
		margin-left: 1.25rem;
	}

	.total .date_search .sx div {
		margin: 0 0.3rem;
		cursor: pointer;
	}
</style>
